// 1. AXIOS PLUGIN MUST BE IMPORTED FIRST to ensure apiClient is installed
import axios from '@/plugins/axios.js'

// 2. Now import other modules
import Vue from 'vue'
import App from './App.vue'
import router from './router' // 手动引入路由
import store from './store' // 手动引入 Vuex Store
import { setupGoogleAnalytics } from '@/plugins/ga.js' // 引入 GA 设置
import { setupRouteTracker } from '@/plugins/track-route.js' // 引入路由追踪设置

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
import notification from 'ant-design-vue/lib/notification'
import message from 'ant-design-vue/lib/message'
import zhCN from 'ant-design-vue/lib/locale/zh_CN'

import '@/static/css/font/iconfont.css'

Vue.use(Antd)

// 设置全局属性
Vue.$message = message
Vue.$notify = notification
Vue.prototype.$locale = zhCN

// 核心插件同步加载
import '@/plugins/antd-ui.js'
import '@/plugins/lazyload.js'
import '@/plugins/moment.js'
import '@/plugins/localStorage.js'
import '@/plugins/vue-inject.js'

// 非首屏必须的插件异步加载
const loadAsyncPlugins = () => {
  // Echarts - 图表功能，按需加载
  import(/* webpackChunkName: "plugin-echarts" */ '@/plugins/echarts.js')
  // Swiper - 轮播图
  import(/* webpackChunkName: "plugin-swiper" */ '@/plugins/vue-swiper.js')
  // 无缝滚动
  import(/* webpackChunkName: "plugin-scroll" */ '@/plugins/vueSeamlessScroll.js')
  // 拖拽
  import(/* webpackChunkName: "plugin-drag" */ '@/plugins/vuedraggable.js')
  // 瀑布流
  import(/* webpackChunkName: "plugin-waterfall" */ '@/plugins/waterfall.js')
  // 图片裁剪
  import(/* webpackChunkName: "plugin-cropper" */ '@/plugins/vue-cropper.js')
  // 数字动画
  import(/* webpackChunkName: "plugin-countup" */ '@/plugins/countup.js')
  // 富文本编辑器
  import(/* webpackChunkName: "plugin-quill" */ '@/plugins/nuxt-quill-plugin.js')
  // 图片预览
  import(/* webpackChunkName: "plugin-photoswipe" */ '@/plugins/photoswipe.js')
}

// 埋点相关插件
import '@/plugins/track-directive.js'
import '@/plugins/track-events.js'

import initWebIM from '@/plugins/webIM.js'

import VueI18n from 'vue-i18n'
import cookie from 'js-cookie'
import { getDomainToLocale } from '~/utils/configFn'
import { getSystemConfig } from '~/utils/config'
import enUS from '@/locales/lang/en-US'
import zhCN_i18n from '@/locales/lang/zh-CN'

Vue.use(VueI18n)

// --- Advanced i18n setup from i18n.js (converted for SPA) ---
const systemConfig = getSystemConfig()
const cookieLocaleKey = systemConfig.locale.cookieLocaleKey
const cookieLocale = cookie.get(cookieLocaleKey)
const defaultLocale = systemConfig.locale.defaultLocale

let toLocale = defaultLocale
const host = window.location.host

if (process.env.NODE_ENV === 'production') {
  toLocale = getDomainToLocale(host)
} else if (process.env.NODE_ENV === 'development') {
  if (cookieLocale) {
    toLocale = cookieLocale
  }
  cookie.set(cookieLocaleKey, toLocale)
}
// --- End of i18n setup ---

const i18n = new VueI18n({
  locale: toLocale, // 使用动态获取的语言
  fallbackLocale: defaultLocale,
  // 暂时禁用翻译功能，$t() 将直接返回传入的 key（中文原文）
  // 将来需要启用 i18n 时，将 silentTranslationWarn 设为 false 并移除 missing 处理器
  silentTranslationWarn: true,
  missing: (locale, key) => {
    // 直接返回 key 作为翻译结果，这样 $t('中文') 会直接显示 '中文'
    return key
  },
  messages: {
    en: enUS,
    zh: zhCN_i18n,
  },
})

// Install WebIM Plugin
// Vue.use(WebIMPlugin, { store });
initWebIM({ store })

// 设置分析和追踪
setupGoogleAnalytics(router)
setupRouteTracker(router, store, axios)

Vue.config.productionTip = false

const app = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')

app.$store.dispatch('initializeApp')

// 延迟加载非首屏必须的插件，避免阻塞首屏渲染
requestIdleCallback ? requestIdleCallback(loadAsyncPlugins) : setTimeout(loadAsyncPlugins, 100)
